import { render, staticRenderFns } from "./Celebs.vue?vue&type=template&id=559ced0a&scoped=true"
import script from "./Celebs.vue?vue&type=script&lang=js"
export * from "./Celebs.vue?vue&type=script&lang=js"
import style0 from "./Celebs.vue?vue&type=style&index=0&id=559ced0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559ced0a",
  null
  
)

export default component.exports